var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHSpecialOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03147 11.1111L11.2537 4.88889M15.1426 8C15.1426 11.866 12.0086 15 8.14258 15C4.27659 15 1.14258 11.866 1.14258 8C1.14258 4.13401 4.27659 1 8.14258 1C12.0086 1 15.1426 4.13401 15.1426 8ZM12.0315 10.3333C12.0315 11.1925 11.335 11.8889 10.4759 11.8889C9.61678 11.8889 8.92036 11.1925 8.92036 10.3333C8.92036 9.4742 9.61678 8.77778 10.4759 8.77778C11.335 8.77778 12.0315 9.4742 12.0315 10.3333ZM7.3648 5.66667C7.3648 6.5258 6.66838 7.22222 5.80924 7.22222C4.95013 7.22222 4.25369 6.5258 4.25369 5.66667C4.25369 4.80756 4.95013 4.11111 5.80924 4.11111C6.66838 4.11111 7.3648 4.80756 7.3648 5.66667Z",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHSpecialOffersIcon);
export default __webpack_public_path__ + "static/media/h-special-offers-icon.ddb5b7d035a7752dad3b49ca6b279761.svg";
export { ForwardRef as ReactComponent };